function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M91.42,0v8.53h10.59v9.26H91.42v14.76l-9.26,3.73v-18.5H19.85v66.09h62.31V72.62l9.26-3.03v14.31h10.59v9.26H91.42v8.86 h-9.26v-8.86H19.85v8.86h-9.26v-8.86H0v-9.26h10.59V17.79H0V8.53h10.59V0h9.26v8.53h62.31V0H91.42L91.42,0z M85.71,46.3 c3.38,3.98,5.76,8.27,7.04,12.9l27.13-19.8c2.31-1.46,3.72-2.8,2.64-5.94c-0.65-0.99-1.42-1.6-2.31-1.84 c-0.89-0.24-1.9-0.1-3.02,0.42L85.71,46.3L85.71,46.3z M44.95,76.48c8.2-3.73,18.63,4.06,24.92-4.01c1.67-2.14,2.57-5.34,1.99-8.13 c-0.23-1.13-0.7-2.18-1.43-3.06c-0.33-0.39-0.7-0.75-1.13-1.08c-5.33-4.1-12.3-1.2-16.55,3.11C48.85,67.28,46.42,72.72,44.95,76.48 L44.95,76.48z M72.45,57.41c1.55,1.27,3.48,4.03,3.55,6.65l14.44-3.7c-1.41-5.09-3.6-9.64-7.11-13.25 C77.97,51.97,78.34,52.95,72.45,57.41L72.45,57.41z M56.85,46.06L45.16,58.8V39.44H34.15v-9.71h33.71v9.71H56.85V46.06L56.85,46.06 z"
}));

function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 102.01",
    style: {
      enableBackground: "new 0 0 122.88 102.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.7c87ec7d.svg";
export { ForwardRef as ReactComponent };